/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type FollowUpReason from "parog-web/models/follow-up-reason";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    followUpReasonId: FollowUpReason["id"];
  };
}

export default class TreatmentHistoryEditionFormBreastCancerFormRadiotherapySection extends Component<Signature> {
  get radiotherapies() {
    return this.args.changeset.get("radiotherapies");
  }

  @action
  onChangesetUpdate(changeset: EmberChangeset) {
    changeset.execute();
    this.setAsDirty();
  }

  setAsDirty() {
    this.args.changeset.set("radiotherapies", [].concat(this.radiotherapies));
  }
}
